/* eslint-disable @next/next/no-img-element */
import {
  ImageNotFoundElementDataType,
  NotFoundElementDataType,
} from '@/components/sections/builder/elements/body/not-found/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import { ElementProps } from '@/components/sections/builder/types';
import { cn } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import { Images } from 'lucide-react';
import { shallow } from 'zustand/shallow';

const defaultData: ImageNotFoundElementDataType = {
  name: 'Image',
  source: '/assets/notfound.png',
  size: 100,
  sizeMobile: 65,
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ImageNotFoundElementDataType;
  const parentData = element.parentData as NotFoundElementDataType;

  return (
    <div
      className={cn(
        'relative flex h-full w-full items-center',
        parentData.alignment?.includes('Left') && 'justify-start',
        (parentData.alignment?.includes('Center') || !parentData.alignment) && 'justify-center',
        parentData.alignment?.includes('Right') && 'justify-end'
      )}
    >
      <img src={data.source} alt={data.name} className='image-width' />
      <style jsx>{`
        .image-width {
          width: ${data.size ?? 100}px;
        }

        @media (max-width: 768px) {
          .image-width {
            width: ${data.sizeMobile ?? 65}px;
          }
        }
      `}</style>
    </div>
  );
};

export const ElementSetting = ({ element }: ElementProps) => {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as ImageNotFoundElementDataType;

  return (
    <div>
      <ImageSetting
        value={data?.source}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            source: val,
          });
        }}
      />
      <InputSlider
        label='Size on desktop'
        value={data?.size || defaultData.size}
        max={500}
        min={50}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            size: val,
          });
        }}
      />
      <InputSlider
        label='Size on mobile'
        value={Number(data?.sizeMobile) || Number(defaultData.sizeMobile)}
        max={250}
        min={50}
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, {
            sizeMobile: val,
          });
        }}
      />
    </div>
  );
};

export const ElementPreviewIcon = Images;

const ImageNotFound = {
  type: 'not_found_image',
  group: 'not_found',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default ImageNotFound;
